import * as React from 'react';

const SvgUsingErgStoreItLight = (props) => (
  <svg
    width="auto"
    height="auto"
    viewBox="0 0 258 388"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="m1.453 384.144 19.301.504c16.514-40.25 31.012-75.992 44.325-115.175 4.654-13.763 7.856-23.729 10.792-31.678 5.93-15.127 10.791-22.157 24.281-31.738 15.714-11.123 33.681-19.131 48.831-30.818 5.93-4.597 2.52-11.212-2.638-6.466a71.487 71.487 0 0 1-14.291 10.144c-9.725 5.636-19.716 9.729-32.139 16.106-20.042 10.293-29.203 20.763-36.556 47.458C48.416 297.029 29.5 333.097 1.453 384.144Z"
      fill="url(#using-erg-store-it-light_svg__a)"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="m40.973 385.212 23.214.563 12.571-40.488c5.485-18.004 6.553-31.5-10.525-42.623a89.757 89.757 0 0 0-19.864-8.898c-2.313 5.932-2.313 5.546-4.744 11.301 22.8 11.597 22.977 21.178 14.38 44.492l-15.032 35.653Z"
      fill="url(#using-erg-store-it-light_svg__b)"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="m42.428 385.212 6.138.178 13.994-38.797c8.894-24.619 4.98-30.344-20.932-41.793-1.483 3.53-.978 2.373-2.55 5.932 23.215 7.03 25.438 14.831 18.086 34.852l-14.736 39.628Z"
      fill="url(#using-erg-store-it-light_svg__c)"
    />
    <path
      d="M1.453 384.144C29.5 333.097 48.416 297.029 63.36 242.541c7.353-26.695 16.514-37.225 36.556-47.458 12.423-6.377 22.414-10.471 32.139-16.106a75.073 75.073 0 0 0 19.212-14.979c1.957-2.136 3.766-3.767 5.396-3.856 3.855-.238 7.116 5.487 5.307 12.606a30.64 30.64 0 0 1-8.568 13.674c-8.035 8.008-18.501 11.686-27.069 18.894-7.857 6.614-2.046 11.598 8.331 6.525a898.703 898.703 0 0 1 29.263-13.08c33.384-14 43.85-28.297 64.604-43.691 5.574-4.094 15.625-5.132 16.929 3.678 9.636-2.017 14.824 4.182 7.59 11.301l-7.353 7.118c5.574.178 8.094 5.933 2.55 12.013l-14.409 11.865c7.382.326 9.665 3.411 8.894 7.919-.563 3.441-6.7 7.772-9.398 9.818l-48.564 36.484-31.665 17.796c-44.887 25.272-43.168 30.937-54.375 80.739l-7.174 32.716"
      stroke="#141414"
      strokeWidth={3}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M246.022 158.54c-9.724 2.966-23.363 17.026-32.198 24.204a193.636 193.636 0 0 1-29.648 19.487M245.726 177.107c-7.59.831-12.245 4.895-17.789 9.492-6.701 5.547-18.886 15.038-25.35 19.636a130.201 130.201 0 0 1-17.403 10.47M236.207 200.926a26.974 26.974 0 0 0-13.49 5.784c-20.754 16.521-20.428 17.114-45.451 29.958"
      stroke="#141414"
      strokeWidth={3}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M123.694 208.015c-6.612 9.491-5.93 21.534-11.444 31.915a30.105 30.105 0 0 1-11.504 11.865"
      stroke="#141414"
      strokeWidth={3}
      strokeMiterlimit={10}
      strokeLinecap="round"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M118.148 27.97h56.421v195.261l-56.421 21.208V27.971Z"
      fill="url(#using-erg-store-it-light_svg__d)"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M74.151 242.63c-3.765 13.407-3.498 20.763 3.35 38.204-5.544-3.589-8.894-10.322-15.595-11.45l3.173-17.174 9.072-9.58Z"
      fill="#141414"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M121.204 293.588c-.889-9.166 2.283-11.865 10.051-16.996l13.816-8.899c8.361-5.398 15.061-8.275 23.066-.237 4.418 4.479 1.809 7.178-1.956 9.492-11.445 6.94-22.652 13.881-33.948 21.089-3.854 2.847-10.169 4.894-11.029-4.449Z"
      fill="#141414"
      stroke="#141414"
      strokeMiterlimit={10}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="m121.349 294.893 3.528 5.25h-8.775l5.247-5.25Z"
      fill="#141414"
      stroke="#141414"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M100.98 223.736c-3.439 8.661-9.902 16.936-17.996 18.152-12.186 1.958-13.905-18.983-1.216-31.411 14.054-13.733 28.433-9.966 19.212 13.259Z"
      fill="#FF5E18"
    />
    <path
      d="M146.346 3.678c-.311.008-.616.09-.889.237l-18.382 7.623a2.165 2.165 0 0 0-1.157 1.127l-7.679 18.598a2.559 2.559 0 0 0 0 1.631l7.679 18.39a2.082 2.082 0 0 0 1.157 1.246l18.382 7.593a1.6 1.6 0 0 0 .889.178c.289.03.579-.032.83-.178l18.412-7.593c.553-.238.99-.686 1.215-1.246l7.59-18.39a1.744 1.744 0 0 0 0-1.631l-7.59-18.509a2.37 2.37 0 0 0-1.215-1.127l-18.412-7.623a1.687 1.687 0 0 0-.83-.326Zm0 5.16 16.366 6.793 6.7 16.344-6.7 16.373-16.366 6.703-16.336-6.703-6.79-16.373 6.79-16.344 16.336-6.792Z"
      fill="#141414"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="m169.441 31.136-6.731-16.373L146.374 8l-16.366 6.763-6.789 16.373 6.789 16.373 16.366 6.703 16.336-6.703 6.731-16.373Z"
      fill="#141414"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M144.564 35.505h10.881v5.16h-18.234V35.98l7.204-7.92-7.204-7.533v-4.568h18.234v5.072h-10.644l6.641 6.94-6.878 7.535Z"
      fill="#fff"
    />
    <path
      d="M146.343 0a3.168 3.168 0 0 0-.889.178L127.072 7.86a1.862 1.862 0 0 0-1.156 1.157l-7.679 18.39c-.17.561-.17 1.16 0 1.72l7.679 18.42a2.039 2.039 0 0 0 1.156 1.216l18.382 7.593c.286.102.586.162.889.179.285-.014.565-.074.831-.178l18.411-7.594a2.229 2.229 0 0 0 1.216-1.216l7.59-18.42a1.958 1.958 0 0 0 0-1.72l-7.59-18.39a2.049 2.049 0 0 0-1.216-1.157L147.174.178a2.616 2.616 0 0 0-.831-.178Zm0 5.161 16.366 6.793 6.701 16.343-6.701 16.284-16.366 6.792-16.336-6.792-6.789-16.284 6.789-16.344 16.336-6.792Z"
      fill="#fff"
    />
    <path
      d="M146.343 94.175a2.963 2.963 0 0 0-.889.148l-18.382 7.682a1.937 1.937 0 0 0-1.156 1.157l-7.679 18.39c-.17.561-.17 1.16 0 1.721l7.679 18.419c.096.273.248.523.448.732.199.21.44.375.708.484l18.382 7.623c.291.078.589.128.889.149.282-.018.56-.068.831-.149l18.411-7.623a2.225 2.225 0 0 0 1.216-1.216l7.59-18.419a1.959 1.959 0 0 0 0-1.721l-7.59-18.39a2.138 2.138 0 0 0-1.216-1.157l-18.411-7.682a2.585 2.585 0 0 0-.831-.148Zm0 5.131 16.366 6.793 6.701 16.373-6.701 16.284-16.366 6.763-16.336-6.763-6.789-16.284 6.789-16.373 16.336-6.793Z"
      fill="#141414"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="m169.441 121.136-6.731-16.344L146.374 98l-16.366 6.792-6.789 16.344 6.789 16.284 16.366 6.792 16.336-6.792 6.731-16.284Z"
      fill="#141414"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M144.564 125.883h10.881v5.072h-18.234v-4.568l7.204-8.009-7.204-7.445v-4.597h18.234v5.072h-10.644l6.641 6.97-6.878 7.505Z"
      fill="#fff"
    />
    <path
      d="M146.342 90.408a2.957 2.957 0 0 0-.889 0l-18.382 7.623a2.051 2.051 0 0 0-1.156 1.216l-7.679 18.419a2.73 2.73 0 0 0 0 1.691l7.679 18.42a2.054 2.054 0 0 0 1.156 1.216l18.382 7.623c.295.045.595.045.889 0 .275.045.556.045.831 0l18.411-7.623a2.228 2.228 0 0 0 1.216-1.216l7.59-18.42a1.907 1.907 0 0 0 0-1.691l-7.59-18.42a2.224 2.224 0 0 0-1.216-1.215l-18.411-7.623a2.58 2.58 0 0 0-.831 0Zm0 5.131 16.366 6.792 6.701 16.285-6.701 16.373-16.366 6.792-16.336-6.792-6.789-16.373 6.789-16.285 16.336-6.792Z"
      fill="#fff"
    />
    <path
      d="M146.346 198.79a1.856 1.856 0 0 0-.889.149l-18.382 7.622a2.168 2.168 0 0 0-1.157 1.128l-7.679 18.449a2.558 2.558 0 0 0 0 1.631l5.93 14.564 4.566-1.809-5.633-13.585 6.789-16.344 16.336-6.792 16.366 6.792 5.93 14.564 4.595-1.809-6.463-15.721a2.373 2.373 0 0 0-1.215-1.127l-18.412-7.623a1.598 1.598 0 0 0-.682-.089Z"
      fill="#141414"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="m170 225.069-6.189-15.04L146.929 203l-16.913 7.029L123 226.942 128.852 241 170 225.069Z"
      fill="#141414"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M144.564 230.439h10.555l-13.164 5.161h-4.744v-4.656l7.204-7.95-7.204-7.534v-4.567h18.234v5.072h-10.644l6.641 6.94-6.878 7.534Z"
      fill="#fff"
    />
    <path
      d="M146.343 194.935a3.142 3.142 0 0 0-.889.178l-18.382 7.682a1.861 1.861 0 0 0-1.156 1.157l-7.679 18.39a2.964 2.964 0 0 0 0 1.72l7.442 17.797 5.069-2.047-.741-.237-6.789-16.373 6.789-16.344 16.336-6.792 16.366 6.792 6.701 16.344-.801 2.046 5.93-2.372a1.993 1.993 0 0 0-.178-.564l-7.59-18.39a2.04 2.04 0 0 0-1.215-1.157l-18.412-7.682a2.608 2.608 0 0 0-.801-.148Z"
      fill="#fff"
    />
    <path
      d="M177.987 223 117 246.551"
      stroke="#141414"
      strokeWidth={3}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <defs>
      <linearGradient
        id="using-erg-store-it-light_svg__a"
        x1={51.5}
        y1={267.5}
        x2={23.544}
        y2={368.512}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#141414" />
        <stop offset={1} stopColor="#fff" stopOpacity={0} />
      </linearGradient>
      <linearGradient
        id="using-erg-store-it-light_svg__b"
        x1={41}
        y1={307}
        x2={51.529}
        y2={393.496}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FF5E18" />
        <stop offset={1} stopColor="#fff" stopOpacity={0} />
      </linearGradient>
      <linearGradient
        id="using-erg-store-it-light_svg__c"
        x1={48}
        y1={318}
        x2={53}
        y2={369.5}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#141414" />
        <stop offset={1} stopColor="#141414" stopOpacity={0} />
      </linearGradient>
      <linearGradient
        id="using-erg-store-it-light_svg__d"
        x1={94.874}
        y1={223.943}
        x2={96.358}
        y2={54.873}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FF5E18" stopOpacity={0} />
        <stop offset={1} stopColor="#FF5E18" />
      </linearGradient>
    </defs>
  </svg>
);

export default SvgUsingErgStoreItLight;
